import React, { useState } from 'react';
import Text from '../../../atoms/Text';
import Button from '../../../molecules/Button';
import { validateEmail } from './validation';
import { SubscriptionMethod } from '../../../pages/SubscriptionPage/SubscriptionBody';
import ExpandableParamField from '../../Trading/common/ExpandableParamField';
import GraphTooltip from '../../Trading/common/GraphTooltip';

import './styles.scss';
import '../../Trading/styles.scss';

interface IPaymentModalProps {
  title: string;
  subtitle: string;
  description: string;
  icon: string;
  iconColor: string;
  buttonText(method: SubscriptionMethod): string;
  onSubmit: (value: string, methd: SubscriptionMethod) => Promise<void> | void;
  onCancel?: () => void;
}

const PaymentModal = ({
  title,
  subtitle,
  description,
  icon,
  iconColor,
  buttonText,
  onSubmit,
  onCancel,
}: IPaymentModalProps) => {
  const [email, setEmail] = useState('');
  const [code, setCode] = useState('');
  const [method, setMethod] = useState<SubscriptionMethod>(
    SubscriptionMethod.email
  );
  const [loading, setLoading] = useState(false);

  const handleEmailChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const text = e.target.value;

    return setEmail(text);
  };

  const handleCodeChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const text = e.target.value;

    return setCode(text.trim());
  };

  const handleSubmit = async () => {
    setLoading(true);
    await onSubmit(method === SubscriptionMethod.email ? email : code, method);
    setLoading(false);
    onCancel?.();
  };

  const toggleEmail = () => {
    if (method === SubscriptionMethod.email) {
      setMethod(SubscriptionMethod.code);
    } else {
      setMethod(SubscriptionMethod.email);
    }
  };

  const toggleCode = () => {
    if (method === SubscriptionMethod.code) {
      setMethod(SubscriptionMethod.email);
    } else {
      setMethod(SubscriptionMethod.code);
    }
  };

  const isEmailValid = validateEmail(email);
  const isCodeValid = !!code;

  return (
    <>
      <div className='edit_profile_modal__backdrop' onClick={onCancel} />
      <div className='edit_profile_modal payment_modal trading'>
        <div className='edit_profile_modal__header'>
          <Text size={16}>{title}</Text>
          <div
            className='edit_profile_modal__header__close icon-close'
            onClick={onCancel}
          />
        </div>
        <div className='edit_profile_modal__body'>
          <div
            className={`payment_modal__icon ${icon}`}
            style={{ color: iconColor }}
          />
          <div className='payment_modal__text'>
            <Text size={12}>{subtitle}</Text>
            <Text size={12}>{description}</Text>
          </div>
          <div className='edit_profile_modal__body__socials'>
            <div className='params_panel'>
              <ExpandableParamField
                title='Payment datails'
                expanded={method === SubscriptionMethod.email}
                onExpand={toggleEmail}
                getTooltip={() => (
                  <GraphTooltip
                    title='Please note:'
                    description='This link will open in a new browser window. Ensure that your pop-up blocker allows for the opening of new windows to access the content.'
                  />
                )}
              />
              {method === SubscriptionMethod.email && (
                <div className='edit_profile_modal__body__socials__item'>
                  <Text
                    size={12}
                    className='edit_profile_modal__body__socials__item__label'
                  >
                    Email
                  </Text>
                  <div
                    className={`field payment_modal__field ${
                      !isEmailValid ? 'payment_modal__field--error' : ''
                    }`}
                  >
                    <input
                      type='text'
                      className='field'
                      value={email}
                      placeholder='@mail.com'
                      onChange={handleEmailChange}
                    />
                  </div>
                </div>
              )}
            </div>
            <div className='watchlist__search_divider'>
              <Text
                size={14}
                className='watchlist__search_divider__search text--grey-400'
              >
                OR
              </Text>
            </div>
            <div className='params_panel'>
              <ExpandableParamField
                title='Apply a promo code'
                expanded={method === SubscriptionMethod.code}
                onExpand={toggleCode}
                getTooltip={() => (
                  <GraphTooltip
                    title='Warning:'
                    description='The promo code for one account can only be entered once.'
                  />
                )}
              />
              {method === SubscriptionMethod.code && (
                <div className='edit_profile_modal__body__socials__item'>
                  <Text
                    size={12}
                    className='edit_profile_modal__body__socials__item__label'
                  >
                    Promo Code
                  </Text>
                  <div
                    className={`field payment_modal__field ${
                      !isCodeValid ? 'payment_modal__field--error' : ''
                    }`}
                  >
                    <input
                      type='text'
                      className='field'
                      value={code}
                      placeholder='e.x 1234567890...'
                      onChange={handleCodeChange}
                    />
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
        <div className='payment_modal__btn'>
          <Button
            size='m'
            variant='primary'
            action={handleSubmit}
            text={buttonText(method)}
            loading={loading}
          />
        </div>
      </div>
    </>
  );
};

export default PaymentModal;
